import angular from "angular";

angular
    .module('app')
    .component('videoForm', {
        template: require('./video-form.html'),
        controller: ['$sce', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($sce) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.video = $ctrl.resolve.video;
        $ctrl.source = [
            {src: $sce.trustAsResourceUrl($ctrl.video.url), type: "video/mp4"},
        ];
    };
}
